/* eslint-disable no-unused-vars */

class XProtect {

  static NativeProps(others){
    let {
      // XInput specific props
      focus_bColor,
      keyboardType,
      // HStack/VStack specific props
      HAlign,
      VAlign,
      spacing,
      // XDiv custom props that shouldn't reach DOM
      lockWidth,
      lockHeight,
      shadow,
      shadowSize,
      shadowColor,
      fullWidth,
      fullHeight,
      fitWidthToContent,
      fitHeightToContent,
      autoWidth,
      autoHeight,
      round,
      bW,
      bStyle,
      bColor,
      bgColor,
      p,
      pH,
      pV,
      pT,
      pB,
      pL,
      pR,
      m,
      mH,
      mV,
      mT,
      mB,
      mL,
      mR,
      colorTransition,
      sizeTransition,
      positionTransition,
      allTransition,
      transitionDuration,
      noPropagation,
      userSelectNone,
      noTouchAction,
      overflowScroll,
      fadingEdgeLength,
      iconRatio,
      addOns,
      ..._others
    } = others;
    
    return _others;
  }

}

export default XProtect;